import { IconButton } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { IntroValueDialog } from "authoring/routes/project/amends/components/intro-value-dialog"

const INTRO_KEYS = ["intro", "introContent", "introNote"]

function getIntroKey(tailored) {
    if (!tailored) return null
    return INTRO_KEYS.find((key) => Object.prototype.hasOwnProperty.call(tailored, key)) ?? null
}

export function AuthoringIntroValueAction({ original, tailored, entry }) {
    const dialog = useDialog(<IntroValueDialog />, { maxWidth: "lg", fullWidth: true })
    const { projectId, scheduleId } = useBoundContext()

    const introKey = getIntroKey(tailored)
    if (!introKey) return null

    return (
        <IconButton
            aria-label="View introduction comparison"
            size="small"
            color="primary"
            sx={{ p: 0.25 }}
            onClick={showIntroComparison}
            data-cy="intro-tailored-value-view-comparison"
        >
            <Iconify icon="mdi:eye" width={16} />
        </IconButton>
    )

    async function showIntroComparison() {
        await dialog({
            originalIntro: original?.[introKey],
            tailoredIntro: tailored?.[introKey],
            entry,
            projectId,
            scheduleId,
            editMode: false,
        })
    }
}
